import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined } from '@ant-design/icons';
import { useDispatch } from "react-redux";

import {
  Layout,
  Table,
  Row,
  Typography,
  Card,
  Select,
  Form,
  DatePicker,
  Col,
  InputNumber,
  Divider,
  Button,
  Modal,
  Descriptions,
  Spin
} from "antd";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";

import MainLayout from '../../../../../components/layouts/MainLayout';
import TopContent from '../../../../../components/layouts/TopContent';
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import CustomButton from '../../../../../components/custom/CustomButton';
import TextArea from 'antd/es/input/TextArea';
import appStatic from '../../../../../config/appStatic';
import styles from "../../../../../assets/styles/styles";


const { Text } = Typography

const columns = [

  {
    title: '',
    children: [
      {
        title: "Date",
        dataIndex: "date",
      }
    ]
  },
  {
    title: 'Loan Amount and Balance',
    children: [
      {
        title: "Principal Due",
        dataIndex: "principalDue",
      },
      {
        title: "Balance Of Loan",
        dataIndex: "balanceOfLoan",
      },
    ]
  },
  {
    title: 'Total Cost of Loan',
    children: [
      {
        title: "Interest",
        dataIndex: "interest",
      },
      {
        title: "Fees",
        dataIndex: "fees",
      },
      {
        title: "Penalties",
        dataIndex: "penalties",
      },
    ]
  },

  {
    title: 'Installment Totals',
    children: [
      {
        title: "Due",
        dataIndex: "due",
      },
      {
        title: "Oustanding",
        dataIndex: "outstanding",
      },
    ]
  },


];

const RescheduleRequest = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { monthList } = appStatic
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [rescheduleReasons, setRescheduleReasons] = useState([]);
  const [rescheduleRequestTemplate, setRescheduleRequestTemplate] = useState([]);
  const [newRepaymentSchedule, setNewRepaymentSchedule] = useState([]);
  const [showRepaymentSchedule, setShowRepaymentSchedule] = useState(false);
  const childref = useRef();
  const rejChildref = useRef();

  useEffect(() => {
    getDetail();
  }, []);

  function getDetail() {
    const url = `${apiConfig.rescheduleloans}/${state.resourceId}`

    let body = {
      session
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;
        setRescheduleRequestTemplate(objList)

        const tempLoanTermsData = []

        objList?.loanTermVariationsData?.forEach((element) =>
          tempLoanTermsData.push({
            id: element?.id,
            value: element?.decimalValue ? element.decimalValue : "-",
            dateValue: element?.dateValue ? element.dateValue : "-",
          })
        )
        setRescheduleReasons(tempLoanTermsData)

        dispatch({type: cnt.RIGHT_APPROVE_BTN});
        dispatch({type: cnt.RIGHT_REJECT_BTN});

      }
    });
  }

  function getTemplate() {

    const params = {
      command: "previewLoanReschedule"
    }

    const url = `${apiConfig.rescheduleloans}/${state.resourceId}`

    let body = {
      session,
      params
    };

    setIsLoading(true)
    BOM.FetchReqAction(body, url, (err, res) => {

      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        setIsLoading(false)
        const objList = res;

        const tempNewRepaymentSchedule = []

        objList?.periods?.forEach((element) => {
          tempNewRepaymentSchedule.push({
            key: element?.id,
            id: element?.id,
            date: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            paidDate: element?.fromDate
              ? BOM.DateTime(element?.fromDate, "only-date")
              : "-",
            days: element?.daysInPeriod ? element?.daysInPeriod : "-",
            principalDue: element?.principalDue ? element?.principalDue : "-",
            balanceOfLoan: element?.principalLoanBalanceOutstanding
              ? element?.principalLoanBalanceOutstanding
              : "-",
            interest: element?.interestDue ? element?.interestDue : "-",
            fees: element?.feeChargesDue
              ? element?.feeChargesDue
              : element?.feeChargesDue === 0
                ? "0"
                : "-",
            penalties: element?.penaltyChargesDue
              ? element?.penaltyChargesDue
              : element?.penaltyChargesDue === 0
                ? "0"
                : "-",
            due: element?.totalDueForPeriod
              ? element?.totalDueForPeriod
              : element?.totalDueForPeriod === 0
                ? "0"
                : "-",
            paid: element?.principalPaid
              ? element?.principalPaid
              : element?.principalPaid === 0
                ? "0"
                : "-",
            inAdvance: element?.totalPaidInAdvanceForPeriod
              ? element?.totalPaidInAdvanceForPeriod
              : element?.totalPaidInAdvanceForPeriod === 0
                ? "0"
                : "-",
            late: element?.totalPaidLateForPeriod
              ? element?.totalPaidLateForPeriod
              : element?.totalPaidLateForPeriod === 0
                ? "0"
                : "-",
            outstanding: element?.totalOutstandingForPeriod
              ? element?.totalOutstandingForPeriod
              : "-",
          });
        });

        setNewRepaymentSchedule(tempNewRepaymentSchedule)
      }
    });
  }

  function onCancel() {
    navigate("/detail-loan-account", { state: state });
  }

  function handleShowRepaymentSchedule() {
    switch (showRepaymentSchedule) {
      case false:
        setShowRepaymentSchedule(true)
        break;
      case true:
        setShowRepaymentSchedule(false)
      default:
        break;
    }
    getTemplate()
  }

  function handleOnActivateApprove() {
    childref?.current?.showModal();
  }

  function handleOnActivateReject() {
    rejChildref?.current?.showModal();
  }

  const onSubmit = (formValues) => {

    formValues.rescheduleFromDate = BOM.DateTime(formValues.rescheduleFromDate, "only-date")
    // formValues.endDate = BOM.DateTime(formValues.endDate, "only-date")
    formValues.adjustedDueDate = BOM.DateTime(formValues.adjustedDueDate, "only-date")
    formValues.submittedOnDate = BOM.DateTime(formValues.submittedOnDate, "only-date")

    formValues.loanId = state.id

    delete formValues.newFixedPrincipalPercentagePerInstallment

    const params = {
      command: "reschedule"
    }
    const url = `${apiConfig.rescheduleloans}`

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      session,
      params
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.rescheduleMsg);
        navigate("/detail-loan-account", { state: state });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const items = [
    {
      label: labelConfig.rescheduleFromInstallment,
      children: rescheduleRequestTemplate?.rescheduleFromDate
        ? (`${rescheduleRequestTemplate?.rescheduleFromDate[2]} ${monthList[rescheduleRequestTemplate?.rescheduleFromDate[1] - 1]} ${rescheduleRequestTemplate?.rescheduleFromDate[0]}`)
        : "-"
    },
    // {
    //   label: labelConfig.reasonForRescheduling,
    //   children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    // },
    {
      label: labelConfig.submittedOn,
      children: rescheduleRequestTemplate?.timeline?.submittedOnDate
        ? (`${rescheduleRequestTemplate?.timeline?.submittedOnDate[2]} ${monthList[rescheduleRequestTemplate?.timeline?.submittedOnDate[1] - 1]} ${rescheduleRequestTemplate?.timeline?.submittedOnDate[0]}`)
        : "-"
    },
    {
      label: labelConfig.installmentRescheduledTo,
      children: rescheduleReasons[1]
        ? (`${rescheduleReasons[1]?.dateValue[2]} ${monthList[rescheduleReasons[1]?.dateValue[1] - 1]} ${rescheduleReasons[1]?.dateValue[0]}`)
        : "-"
    },
    // {
    //   label: labelConfig.introduceGracePeriod,
    //   children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    // },
    {
      label: labelConfig.principalGracePeriods,
      children: rescheduleReasons[2] ? rescheduleReasons[2]?.value : "-"
    },
    {
      label: labelConfig.interestGracePeriods,
      children: rescheduleReasons[4] ? rescheduleReasons[4]?.value : "-"
    },
    // {
    //   label: labelConfig.extendRepaymentPeriod,
    //   children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    // },
    {
      label: labelConfig.numberOfRepayments,
      children: rescheduleReasons[0] ? rescheduleReasons[0]?.value : "-"
    },
    // {
    //   label: labelConfig.adjustInterestRates,
    //   children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    // },
    {
      label: labelConfig.newInterestRates,
      children: rescheduleReasons[3] ? rescheduleReasons[3]?.value : "-"
    },
    // {
    //   label: labelConfig.changeFixedPrincipal,
    //   children: rescheduleRequestTemplate?.rescheduleReasonCodeValue?.name
    // },
  ];

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnActivateApprove()}
      onReject={() => handleOnActivateReject()}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.rescheduleRequest}
        pageItems={staticConfig.rescheduleRequestBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >

            <Row >

              <Descriptions
                bordered
                column={{
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 2,
                  xl: 2,
                  xxl: 2,
                }}
                style={{ marginTop: 10, marginBottom: 20 }}
                items={items}
              />
            </Row>

            <Row>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.comment}
                  name={"comment"}
                >
                  <TextArea style={{ width: "100%", height: "10vh" }} placeholder='Please enter a comment' />

                </Form.Item>
              </Col>

              <Divider orientation="left"></Divider>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item>
                  <Button
                    type="primary"
                    icon={<FolderOpenOutlined />}
                    shape='round'
                    style={{
                      backgroundColor: "#15CCAE",
                      color: "white",
                      width: "30vh",
                      marginTop: 30,
                    }}
                    onClick={handleShowRepaymentSchedule}
                  >
                    {showRepaymentSchedule === false ? labelConfig.viewRepaymentSchedule : labelConfig.hideRepaymentSchedule}
                  </Button>
                </Form.Item>
              </Col>

              {
                showRepaymentSchedule === true ?

                  <Col span={24} style={{ padding: "0px 8px" }}>
                    <Table
                      columns={columns}
                      dataSource={newRepaymentSchedule}
                    ></Table>
                  </Col>
                  : null
              }

            </Row>

            <Row>
              <Divider />
              <ApproveModal
                session={session}
                state={state}
                navigate={navigate}
                ref={childref}
                userData={userData}
              />
              <RejectModal
                session={session}
                state={state}
                navigate={navigate}
                ref={rejChildref}
                userData={userData}
              />
            </Row>
          </Form>
        </Card>
      </Spin>

    </MainLayout>

  )
}

export default RescheduleRequest

const ApproveModal = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, state } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "approve"
    }

    const url = `${apiConfig.rescheduleloans}/${state.resourceId}`

    formValues.approvedOnDate = BOM.DateTime(formValues.approvedOnDate, "only-date");

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.approveRescheduleMsg);

        navigate("/detail-loan-account", { state: state });
        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Approve Loan Reschedule"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.approvedOn}
                name="approvedOnDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.approvedOn),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});

const RejectModal = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const { currentCustomerObj, userData, state } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setIsModalOpen(true);
    },
  }));

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onSubmit = (formValues) => {
    const params = {
      command: "reject"
    }

    const url = `${apiConfig.rescheduleloans}/${state.resourceId}`

    formValues.rejectedOnDate = BOM.DateTime(formValues.rejectedOnDate, "only-date");

    formValues.dateFormat = "dd MMMM yyyy";

    const body = {
      ...formValues,
      locale: "en",
      method: "POST",
      session,
      params,
    };

    // console.log(body); return
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.rejectRescheduleMsg);

        navigate("/detail-loan-account", { state: state });
        // close modal
        setIsModalOpen(false);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Modal
        title="Reject Loan Reschedule"
        open={isModalOpen}
        okText="Submit"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form layout="vertical" form={useForm}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Loading..." size="large">
          <Row>
            <Divider orientation="left"></Divider>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.rejectedOn}
                name="rejectedOnDate"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.rejectedOn),
                  },
                ]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Spin>
      </Modal>
    </>
  );
});